import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { serialize } from '../../utility/serialize';
import { IRestrictedBrand } from '../../shared/models/product/restricted-brand';
import { RestrictedBrandFilterSet } from '../../shared/models/product/restricted-brand-filter-set';

export const restrictedBrandApi = createApi({
  reducerPath: 'restrictedBrandApi',
  baseQuery,
  tagTypes: ['RestrictedBrands'],
  endpoints: (builder) => ({
    getRestrictedBrands: builder.query<IPagedResult<IRestrictedBrand>, RestrictedBrandFilterSet>({
      query: (filterSet) => ({
        url: `/api/restrictedbrands?${serialize(filterSet)}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetRestrictedBrandsQuery, useLazyGetRestrictedBrandsQuery } = restrictedBrandApi;
